import { useState } from 'react'
import { DialogModal } from '../../../../../components/DialogModal'
import { type ExpertInfoData } from './ExpertInfoContainer'
import { LineInfo } from '../../../../../components/LineInfo'

type MoreInfoModalProps = {
  expertInfoData: ExpertInfoData
}

export const MoreInfoModal = ({ expertInfoData }: MoreInfoModalProps) => {
  const [openDialogModal, setDialogModalOpen] = useState(false)
  const openOrCloseDialogModal = (value: boolean) => {
    setDialogModalOpen(value)
  }

  const formatedLastContactAt = expertInfoData.lastContactAt ? String(expertInfoData.lastContactAt) : 'N/A'

  return (
    <>
      <button
        className="text-xs font-bold text-primary-light border border-primary-light rounded px-1"
        type="button"
        onClick={() => openOrCloseDialogModal(true)}
      >
        Infos Rápidas
      </button>
      <DialogModal
        isOpen={openDialogModal}
        title="Infos Rápidas"
        onClose={() => openOrCloseDialogModal(false)}
        styleBox={{ maxWidth: '36rem' }}
      >
        <div className="w-full flex flex-col justify-center items-center pb-10">
          <div className="my-6">
            <LineInfo
              label="Empresa atual"
              text={expertInfoData.currentCompany}
            />

            <LineInfo label="Nome" text={expertInfoData.name} />

            <LineInfo label="Cargo" text={expertInfoData.position} />

            <LineInfo
              label="Último contato realizado por"
              text={
                expertInfoData.researcherAcronym
                  ? expertInfoData.researcherAcronym
                  : 'Não informado'
              }
            />

            <LineInfo
              label={'Valor'}
              text={new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: expertInfoData?.currency
                  ? `${expertInfoData?.currency}`
                  : 'BRL',
              }).format(
                Number(
                  typeof expertInfoData.value === 'string' &&
                    expertInfoData.value
                )
              )}
            />

            <LineInfo label="Telefone" text={expertInfoData.phone} />

            <LineInfo label="Último contato" text={formatedLastContactAt} />
          </div>
          <button
            className="w-40 py-3 my-3 text-base font-bold text-center whitespace-nowrap text-white rounded-lg bg-primary-light"
            type="button"
            onClick={() => openOrCloseDialogModal(false)}
          >
            Fechar
          </button>
        </div>
      </DialogModal>
    </>
  )
}
